import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  onboardCoach,
  clearCoachOnboardState,
  clearCoachOnboardError,
} from "../redux/Slices/coachOnboardSlice";
import Loader from "./Common/Loader";

function CoachOnboardConfirmation() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("offerID");

  const dispatch = useDispatch();
  const { loading, success, error } = useSelector(
    (state) => state.coachOnboard
  );

  useEffect(() => {
    if (id) {
      dispatch(onboardCoach({ id, offerId: id }));
    }

    return () => {
      dispatch(clearCoachOnboardState());
      dispatch(clearCoachOnboardError());
    };
  }, [id, dispatch]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        {loading && <Loader />}
        {success && (
          <>
            <h2 className="text-green-600 mb-4">
              Account Details Saved Successfully.
            </h2>
            <p className="text-gray-700">
              Thank you for completing your onboarding with Stripe.
              <br />
              Your account has been successfully connected and is now ready to
              receive payments and payouts.
            </p>
          </>
        )}
        {error && (
          <p className="text-red-600">Failed to onboard coach: {error}</p>
        )}
      </div>
    </div>
  );
}

export default CoachOnboardConfirmation;
